<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export const tableRowVariants = cva('transition-colors', {
  variants: {
    size: {
      xs: 'h-8',
      sm: 'h-10',
      md: 'h-12',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

export type TableRowVariants = VariantProps<typeof tableRowVariants>

export interface TableRowProps {
  class?: HTMLAttributes['class']
  size?: TableRowVariants['size']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'

const props = withDefaults(defineProps<TableRowProps>(), {
  size: 'sm',
})
</script>

<template>
  <tr data-slot="table-row" :class="cn(tableRowVariants({ size }), props.class)">
    <slot />
  </tr>
</template>
